"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CognitoFrontend = exports.COGNITO_AUTH_SCOPE = void 0;
const lodash_1 = require("lodash");
const store2_1 = __importDefault(require("store2"));
const qs = __importStar(require("@zipit/ls-core-sdk/dist/querystring"));
const jsonwebtoken_1 = __importDefault(require("jsonwebtoken"));
const superagent = __importStar(require("superagent"));
const getInactivityExpiration_1 = require("../../getInactivityExpiration");
const utils_1 = require("../utils");
exports.COGNITO_AUTH_SCOPE = 'openid+profile+aws.cognito.signin.user.admin+phone+email';
class CognitoFrontend {
    cleanLocationString(locationString, prefix) {
        return locationString
            .replace(`${prefix ? prefix : ''}/id_token`, 'id_token')
            .replace(`${prefix ? prefix : ''}id_token`, 'id_token')
            .replace(`${prefix ? prefix : ''}/access_token`, 'access_token')
            .replace(`${prefix ? prefix : ''}access_token`, 'access_token');
    }
    getQueryString() {
        let pathname = this.cleanLocationString(window.location.pathname);
        let hash = this.cleanLocationString(window.location.hash, '#');
        let search = window.location.search;
        let parseable;
        if (pathname.indexOf('id_token') > -1) {
            parseable = pathname;
        }
        if (hash.indexOf('id_token') > -1) {
            parseable = hash;
        }
        if (search.indexOf('id_token') > -1) {
            parseable = search.substr(1);
        }
        if (hash.indexOf('?') > -1) {
            parseable = hash.substr(hash.indexOf('?'));
        }
        return qs.parse(parseable);
    }
    exchangeCodeForTokens(code, idp) {
        return __awaiter(this, void 0, void 0, function* () {
            const clientId = idp.data.appClientId;
            const body = {
                grant_type: 'authorization_code',
                client_id: clientId,
                redirect_uri: (0, utils_1.getPageOriginUrl)(),
                code,
            };
            let tokens = yield this.cognitoTokenPost(body, idp);
            return tokens;
        });
    }
    refreshCognitoTokens(refreshToken, idp, sessionId) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const clientId = (_a = idp === null || idp === void 0 ? void 0 : idp.data) === null || _a === void 0 ? void 0 : _a.appClientId;
            const body = {
                grant_type: 'refresh_token',
                client_id: clientId,
                refresh_token: refreshToken,
            };
            let tokens = yield this.cognitoTokenPost(body, idp, sessionId);
            return tokens;
        });
    }
    cognitoTokenPost(body, idp, sessionId) {
        return __awaiter(this, void 0, void 0, function* () {
            const loginUrl = idp.data.url;
            let urlBase;
            const regex = new RegExp('auth\..+\.amazoncognito.com');
            if (regex.test(loginUrl)) {
                urlBase = loginUrl.slice(0, loginUrl.indexOf('.com') + 4);
            }
            else {
                urlBase = loginUrl;
            }
            const TOKEN_ENDPOINT = `${urlBase}/oauth2/token`;
            let req = superagent.post(TOKEN_ENDPOINT)
                .set('Content-Type', 'application/x-www-form-urlencoded')
                .send(qs.stringify(body));
            if (sessionId) {
                req.set('portal-session', sessionId);
            }
            let res = yield req;
            return res.body;
        });
    }
    hasQueryCredentials() {
        const queryStr = this.getQueryString();
        const { access_token, id_token, state } = queryStr;
        // if we came through the "code" flow these were stashed into local storage b/c
        // the url gets redirected differently from cognito
        const code = store2_1.default.get('lsOauthCode');
        const codeState = store2_1.default.get('lsOauthState');
        if ((access_token && id_token && state) || (code && codeState)) {
            return true;
        }
        return false;
    }
    hasLocalCredentials() {
        var _a, _b, _c;
        const localCreds = store2_1.default.get('lsAuthParams');
        const id_token = (_a = localCreds === null || localCreds === void 0 ? void 0 : localCreds.data) === null || _a === void 0 ? void 0 : _a.id_token;
        const access_token = (_b = localCreds === null || localCreds === void 0 ? void 0 : localCreds.data) === null || _b === void 0 ? void 0 : _b.access_token;
        const flow = (_c = localCreds === null || localCreds === void 0 ? void 0 : localCreds.data) === null || _c === void 0 ? void 0 : _c.flow;
        const driver = localCreds === null || localCreds === void 0 ? void 0 : localCreds.driver;
        if (access_token && id_token && driver && (0, lodash_1.includes)(['token', 'code'], flow)) {
            // tokens are still good
            return true;
        }
        // couldn't find any tokens to validate in local storage
        return false;
    }
    hasGuest() {
        var _a, _b;
        return !window.location.host.includes('-admin') && ((_b = (_a = window.location) === null || _a === void 0 ? void 0 : _a.pathname) === null || _b === void 0 ? void 0 : _b.includes('/store'));
    }
    getGuestCredentials() {
        return __awaiter(this, void 0, void 0, function* () {
            const [subdomain] = window.location.hostname.split('.');
            let customerName = subdomain;
            if (customerName.endsWith('admin')) {
                customerName = customerName.split('-').slice(0, -1).join('-');
            }
            const { body: { creds } } = yield superagent.post(`/v2/api/guest/${customerName}`);
            return {
                driver: 'cognito',
                credentials: creds,
            };
        });
    }
    getQueryCredentials() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.hasQueryCredentials()) {
                throw new Error('Could not find any credentials for cognito query string authentication');
            }
            const qsParams = this.getQueryString();
            const flow = store2_1.default.remove('lsOauthFlow');
            const localState = store2_1.default.remove('lsAuthNonce');
            let state = store2_1.default.remove('lsOauthState');
            if (!state) {
                state = (0, lodash_1.get)(qsParams, 'state');
            }
            if (localState !== state) {
                throw new Error('Could not match request and response nonce, please reload the page and try to login again. If the error persists, please contact your administrator.');
            }
            let credentials = { flow };
            if (flow === 'code') {
                const idp = store2_1.default.get('lsIdp');
                let code = store2_1.default.remove('lsOauthCode');
                let tokens = yield this.exchangeCodeForTokens(code, idp);
                credentials.access_token = tokens.access_token;
                credentials.id_token = tokens.id_token;
                credentials.refresh_token = tokens.refresh_token;
            }
            if (flow === 'token') {
                credentials.access_token = qsParams.access_token;
                credentials.id_token = qsParams.id_token;
            }
            return {
                driver: 'cognito',
                credentials,
            };
        });
    }
    getLocalCredentials() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.hasLocalCredentials()) {
                throw new Error('Could not find any credentials for cognito local authentication');
            }
            let { data, inactivityExpiration, idp } = store2_1.default.get('lsAuthParams');
            let sessionData = store2_1.default.get('lsSessionData');
            let result = yield this.getAuthHeader(data, idp, sessionData === null || sessionData === void 0 ? void 0 : sessionData.sessionId);
            if (result.expired || inactivityExpiration <= Date.now()) {
                throw new Error('credentials expired, redirecting to login');
            }
            return { driver: 'cognito', credentials: result.data };
        });
    }
    getCredentials() {
        return __awaiter(this, void 0, void 0, function* () {
            // prefer query string members over local storage, as they are more recent
            if (this.hasQueryCredentials()) {
                let creds = yield this.getQueryCredentials();
                return creds;
            }
            else if (this.hasLocalCredentials()) {
                let creds = yield this.getLocalCredentials();
                return creds;
            }
            else if (this.hasGuest()) {
                let creds = yield this.getGuestCredentials();
                return creds;
            }
            else {
                throw new Error('Could not find any query or local credentials for authentication');
            }
        });
    }
    getAuthHeader(data, idp, sessionId) {
        return __awaiter(this, void 0, void 0, function* () {
            // check if the access_token is expired
            let creds = (0, lodash_1.cloneDeep)(data);
            let access_token = (0, lodash_1.get)(creds, 'access_token');
            let expired = false;
            const decoded = jsonwebtoken_1.default.decode(access_token);
            const refresh_token = (0, lodash_1.get)(creds, 'refresh_token');
            // note: use iat for the timestamp the token was issued,
            // the auth_time is the time the user entered their credentials
            // and may be hours into the past depending on the policy of the
            // identity provider, which can cause the expiration offset to
            // automatically make us think the token is expired even when
            // it was just issued and should still be valid
            const expires = refresh_token
                ? (decoded.exp + decoded.iat) * .5
                : decoded.exp;
            const now = Date.now();
            const normalizedExpires = expires * 1000;
            if (normalizedExpires <= now) {
                // access_token is expired, see if we have a refresh token
                if (refresh_token) {
                    let newTokens = yield this.refreshCognitoTokens(refresh_token, idp, sessionId);
                    (0, lodash_1.set)(creds, 'access_token', newTokens.access_token);
                    (0, lodash_1.set)(creds, 'id_token', newTokens.id_token);
                }
                else {
                    expired = true;
                }
            }
            return { headers: { Authorization: `cognito ${creds.access_token}`, 'portal-session': sessionId }, data: creds, expired };
        });
    }
    getLogoutUrl(preloginRes) {
        return (0, utils_1.buildOauthLogoutUrl)({
            url: (0, lodash_1.get)(preloginRes, 'data.url'),
            clientId: (0, lodash_1.get)(preloginRes, 'data.appClientId'),
            logoutRedirect: (0, lodash_1.get)(preloginRes, 'data.logoutUrl'),
        });
    }
    getLoginUrl(preloginRes) {
        var _a, _b;
        let flow = (0, lodash_1.get)(preloginRes, 'data.flow', preloginRes.type === 'admin' ? 'code' : 'token');
        const preferredProvider = (_b = qs.parse((_a = window.location.search) === null || _a === void 0 ? void 0 : _a.substring(1))) === null || _b === void 0 ? void 0 : _b.identity_provider;
        return (0, utils_1.buildOauthLoginUrl)({
            url: preloginRes.data.url,
            clientId: preloginRes.data.appClientId,
            scope: exports.COGNITO_AUTH_SCOPE,
            identityProvider: (0, lodash_1.isEmpty)(preferredProvider) ? (0, lodash_1.get)(preloginRes, 'data.identityProvider') : preferredProvider,
            flow,
        });
    }
    validateParams(params_1, _a) {
        return __awaiter(this, arguments, void 0, function* (params, { basePath, customer, subdomain, sessionId }) {
            var _b;
            const access_token = (_b = params.credentials) === null || _b === void 0 ? void 0 : _b.access_token;
            const idp = store2_1.default.get('lsIdp');
            if (!access_token) {
                throw new Error('Could not find a token to validate, login credentials are incomplete');
            }
            let capabilitiesRes = yield superagent.get(`${basePath}/v2/api/capabilities`)
                .set('Authorization', `${params.driver} ${access_token}`)
                .set('portal-session', sessionId);
            const capabilities = capabilitiesRes.body;
            if (!capabilities.isAdmin && window.location.host.includes('-admin')) {
                store2_1.default.remove('lsRedirect');
                throw new Error('Incorrect credentials');
            }
            return {
                driver: params.driver,
                isAdmin: capabilities.isAdmin,
                isFederated: capabilities.isFederated,
                permissions: capabilities.permissions,
                data: params.credentials,
                inactivityExpiration: (0, getInactivityExpiration_1.getNewInactivityExpiration)(idp),
                customerName: customer,
                subdomain,
                idp,
                capabilities: {
                    name: capabilities.user.name,
                    email: capabilities.user.email,
                    vasStackId: capabilities.vasStackId,
                    vasOrganizationId: capabilities.vasOrganizationId,
                    vasUserId: capabilities.vasUserId,
                    vasCustomerIdentifier: capabilities.vasCustomerIdentifier,
                },
            };
        });
    }
}
exports.CognitoFrontend = CognitoFrontend;
//# sourceMappingURL=cognito.js.map